"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Context = void 0;

var _react = require("react");

// Main context used to communicate data between the root provider and
// individual tooltip instances. It isn't sane to provide default logic,
// so throwing if tooltips are used without a provider in the tree.
var providerMissingError = new Error('No TooltipProvider found!');
var Context = /*#__PURE__*/(0, _react.createContext)({
  get baseUrl() {
    throw providerMissingError;
  },

  get defaultLanguage() {
    throw providerMissingError;
  },

  getCachedData: function getCachedData() {
    throw providerMissingError;
  },
  requestGameData: function requestGameData() {
    throw providerMissingError;
  }
});
exports.Context = Context;